import React from "react";
import {
  Wifi, Car, UtensilsCrossed, Wind, Tv, Coffee, Waves, Dumbbell,
  Bath, Trees, PawPrint, Cigarette, Sparkles, Check,
} from "lucide-react";

const ICONS = {
  wifi: Wifi, "free wifi": Wifi, internet: Wifi,
  parking: Car, "free parking": Car,
  kitchen: UtensilsCrossed, breakfast: Coffee, restaurant: UtensilsCrossed,
  ac: Wind, "air conditioning": Wind, "air conditioner": Wind,
  tv: Tv, television: Tv,
  pool: Waves, "swimming pool": Waves,
  gym: Dumbbell, fitness: Dumbbell,
  bathroom: Bath, "hot water": Bath, geyser: Bath,
  garden: Trees, "pet friendly": PawPrint, "non smoking": Cigarette,
};

const pick = (a) => ICONS[(a || "").toLowerCase().trim()] || Sparkles;

export const AmenityChips = ({ amenities = [], max, testid = "amenity-chips" }) => {
  if (!amenities || amenities.length === 0) return null;
  const list = max ? amenities.slice(0, max) : amenities;
  const rest = max ? amenities.length - list.length : 0;
  return (
    <div className="flex flex-wrap gap-2" data-testid={testid}>
      {list.map((a, i) => {
        const Icon = pick(a);
        return (
          <span key={i} className="inline-flex items-center gap-1.5 rounded-full bg-white border border-black/10 px-3 py-1.5 text-xs text-ink-soft">
            <Icon className="w-3.5 h-3.5 text-ink" aria-hidden="true" />
            {a}
          </span>
        );
      })}
      {rest > 0 && (
        <span className="inline-flex items-center gap-1 rounded-full bg-paper-muted px-3 py-1.5 text-xs text-ink-soft">
          <Check className="w-3.5 h-3.5" aria-hidden="true" /> +{rest} more
        </span>
      )}
    </div>
  );
};

export default AmenityChips;
